<template>
  <v-container>
    <p>Please respond to the following questions</p>
    <v-form v-model="formValid">
      <strong
        >Did you wear headphones in listening to the auditory stimuli to
        complete this task?</strong
      >
      <v-radio-group
        v-model="formData.headphones"
        hide-details=""
        class="mt-0 mb-5"
        :rules="requiredRules"
      >
        <v-radio label="Yes" value="yes"></v-radio>
        <v-radio label="No" value="no"></v-radio>
      </v-radio-group>

      <strong
        >How noisy was your environent in which you completed this task?</strong
      >
      <v-slider
        v-model="formData.noise"
        color="blue"
        track-color="blue"
        hide-details
        min="0"
        max="100"
      >
        <template v-slot:prepend> As quiet as a library </template>
        <template v-slot:append> As noisy as a coffee shop or a mall </template>
      </v-slider>

      <div style="height: 20px"></div>

      <strong>What is your gender?</strong>
      <v-radio-group
        v-model="formData.gender"
        hide-details=""
        class="mt-0 mb-5"
        :rules="requiredRules"
      >
        <v-radio label="Man" value="man"></v-radio>
        <v-radio label="Woman" value="woman"></v-radio>
        <v-radio label="Non-binary" value="nonBinary"></v-radio>
        <v-radio
          label="Another gender (please specify)"
          value="anotherGender"
        ></v-radio>
        <v-text-field
          v-model="formData.anotherGenderSpecify"
          v-if="formData.gender == 'anotherGender'"
          filled
          dense
          placeholder="Please specify"
        ></v-text-field>
      </v-radio-group>

      <strong>How old are you?</strong>
      <v-text-field
        :rules="ageRules"
        v-model="formData.age"
        filled
        dense
      ></v-text-field>

      <strong>What is your occupation?</strong>
      <v-text-field
        :rules="requiredRules"
        v-model="formData.job"
        filled
        dense
      ></v-text-field>

      <strong
        >What racial categories do you identify as? Choose all that
        apply:</strong
      >
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Decline to answer"
        value="decline"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="White or Caucasian"
        value="white"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Latin@"
        value="latin"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Black or African American"
        value="black"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Asian"
        value="asian"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Native Indian or Alaska Native"
        value="nativeIndian"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Native Hawaiian or Pacific Islander"
        value="nativeHawaiian"
      ></v-checkbox>
      <v-checkbox
        class="mt-1"
        hide-details=""
        v-model="formData.race"
        label="Other (please specify)"
        value="other"
      ></v-checkbox>
      <v-text-field
        class="mt-2"
        v-model="formData.raceOtherSpecify"
        v-if="formData.race.indexOf('other') !== -1"
        :rules="requiredRules"
        filled
        dense
        placeholder="Please specify"
      ></v-text-field>

      <div style="height: 20px"></div>
      <strong
        >Please list all the places you have lived for more than 6 months and
        the age(s) you were at the time you lived there.</strong
      >
      <v-text-field
        :rules="requiredRules"
        v-model="formData.cities"
        filled
        dense
        placeholder="example: Ann Arbor, MI: 0-18; Chicago, IL: 18-26"
      ></v-text-field>
      <strong>What is/are your native languages?</strong>
      <v-text-field
        :rules="requiredRules"
        v-model="formData.native_lang"
        filled
        dense
      ></v-text-field>
      <strong>What languages do you speak on a regular basis?</strong>
      <v-text-field
        :rules="requiredRules"
        v-model="formData.reg_lang"
        filled
        dense
      ></v-text-field>
      <strong>Do you have a hearing or language impairment?</strong>
      <v-radio-group
        v-model="formData.impair"
        hide-details=""
        class="mt-0 mb-5"
        :rules="requiredRules"
      >
        <v-radio label="Decline to answer" value="decline"></v-radio>
        <v-radio label="Yes" value="yes"></v-radio>
        <v-radio label="No" value="no"></v-radio>
        <v-radio label="I don't know" value="dontKnow"></v-radio>
      </v-radio-group>

      <section v-if="prime == 1 || prime == 2 || prime == 3">
        <strong
          >In the beginning of this study, you were presented with a statement
          regarding recent findings about uptalk. According to recent studies,
          which gender is most likely to use uptalk?</strong
        >
        <v-radio-group
          v-model="formData.mostUptalk"
          hide-details=""
          class="mt-0 mb-5"
          :rules="requiredRules"
        >
          <v-radio label="Men" value="men"></v-radio>
          <v-radio label="Women" value="women"></v-radio>
          <v-radio label="Both Men & Women" value="both"></v-radio>
          <v-radio label="I don't know" value="dontKnow"></v-radio>
        </v-radio-group>
        <strong
          >Do you agree with these recent studies' findings? Why or why
          not?</strong
        >
        <v-text-field
          class="mt-2"
          v-model="formData.agreeWithRecentStudies"
          :rules="requiredRules"
          filled
          dense
          placeholder="Please specify"
        ></v-text-field>
      </section>

      <v-btn :disabled="!formValid" @click="next"
        >Next<v-icon>chevron_right</v-icon></v-btn
      >
    </v-form>
  </v-container>
</template>


<script>
import { computed, ref } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import {
  ref as fbRef,
  getDatabase,
  set,
  serverTimestamp,
} from "firebase/database";
export default {
  setup() {
    const formValid = ref();
    const formData = ref({ noise: 50, race: [] });
    const requiredRules = [(v) => !!v || "This field is required"];
    const ageRules = [(v) => (v > 0 && v <= 200) || "Valid age required"];
    const prime = computed(() => store.state.prime);

    const next = () => {
      set(
        fbRef(
          getDatabase(),
          store.state.experimentName + "/demographicSurvey/" + store.state.pid
        ),
        { ...formData.value, prime: prime.value, timestamp: serverTimestamp() }
      );
      store.commit("setLocked", false);
      router.push("/end");
    };

    return { formValid, formData, requiredRules, ageRules, prime, next };
  },
};
</script>